import { playerReducer } from "../../../storage/reducers";
import FragmentDataType from "../enums/fragment-data-type";
import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class FumbledSnap extends Fragment {
    constructor(fumbledBy) {
        super();
        this.fumbledBy = fumbledBy;

        this.requiredData = [
            {
                name: "fumbledBy",
                type: FragmentDataType.Player,
                displayName: "Fumbled By",
                title: (team) => `Fumbled By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        return new FragmentSummary(
            `Fumbled snap by ${stringifier.firstInitial(this.fumbledBy)}`
        );
    }

    getPlayers() {
        return [this.fumbledBy];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            fumbledBy: playerReducer(this.fumbledBy)
        };
    }
}
